import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { withTranslation } from 'react-i18next';

import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import PictureList from '../../components/PictureList';
import NavBar from '../../components/NavBar';
import UploadModal from '../../components/UploadModal';
import ViewLarge from '../modals/ViewLarge';
import RemovePicture from '../modals/RemovePicture';
import {
  UPLOAD_PICTURE_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import Form from './Form';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
      selectedPicture: null,
      showLarge: false,
      showDelete: false,
      pictures: [],
    };
    this.pictureList = null;
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  getToken(id, callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/pictures/${id}/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
  }
  handleRefetch() {
    if (this.pictureList) {
      this.pictureList.getWrappedInstance().handleRefetch();
    }
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
    });
  }
  handleViewLarge = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
      showLarge: true,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
      selectedPicture: null,
    });
  }
  handleDelete = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
      showDelete: true,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
    }, () => {
      this.deletePicture();
    });
  }
  async uploadPicture(e, body) {
    e.preventDefault();
    const { t } = this.props;
    const { store } = this.context;
    try {
      await this.form.getWrappedInstance().submit('/pictures/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.props.token,
        },
        body,
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.uploadModal.close();
    this.handleRefetch();
    store.dispatch(flashSuccessMessage({ header: t('Upload Success', { ns: TRANSLATION_FILES.translation }), message: t('Pictures(s) successfully uploaded', { ns: TRANSLATION_FILES.translation }) }));
  }
  deletePicture() {
    const { t } = this.props;
    const { store } = this.context;
    this.getToken(this.state.selectedPicture.id, (token) => {
      store.dispatch(fetchM(`/pictures/${this.state.selectedPicture.id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
      }))
        .then(() => {
          this.setState({
            selectedPicture: null,
            loading: false,
          });
          this.handleRefetch();
          store.dispatch(flashSuccessMessage({ header: t('Delete Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture successfully deleted', { ns: TRANSLATION_FILES.translation }) }));
        })
        .catch((err) => {
          store.dispatch(flashErrorMessage(err));
        });
    });
  }
  updatePicture() {
    const { t } = this.props;
    const { store } = this.context;
    this.getToken(this.state.selectedPicture.id, (token) => {
      store.dispatch(fetchM(`/pictures/${this.state.selectedPicture.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
        body: JSON.stringify(this.state.selectedPicture),
      }))
        .then(() => {
          this.setState({
            selectedPicture: null,
            options: [],
            loading: false,
          });
          this.handleRefetch();
          store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture successfully updated', { ns: TRANSLATION_FILES.translation }) }));
        })
        .catch((err) => {
          store.dispatch(flashErrorMessage(err));
        });
    });
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form.getWrappedInstance().state.uploads.length > 0) {
      const callback = () => {
        this.uploadModal.close();
        this.handleRefetch();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(UPLOAD_PICTURE_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  handleGetPictures = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedPicture } = this.state;
    const index = pictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: pictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedPicture } = this.state;
    if (selectedPicture) {
      const index = pictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Pictures')}
          rightNav={
            <Menu.Item fitted>
              <UploadModal
                ref={(ref) => { this.uploadModal = ref; }}
                header="Pictures"
                loading={this.state.loading}
                onConfirm={(e, data) => {
                  this.uploadPicture(e, data);
                }}
                onClose={this.handleCheckBeforeClose}
                content={({ onConfirm }) => (
                  <Form
                    ref={(ref) => { this.form = ref; }}
                    onSubmit={onConfirm}
                  />
                )}
              />
            </Menu.Item>
          }
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedPicture}
          onSlide={this.handleSlidePicture}
          disabledLeft={!this.checkDisabled('left')}
          disabledRight={!this.checkDisabled('right')}
          slideshow={this.state.showLarge}
        />
        <RemovePicture
          type="delete"
          open={this.state.showDelete}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          picture={this.state.selectedPicture}
        />
        <PictureList
          ref={(ref) => { this.pictureList = ref; }}
          toggleable
          onChange={this.handleGetPictures}
          onViewLarge={this.handleViewLarge}
          onRemove={this.handleDelete}
          buttonNode={({ isMobile, view, loading, picture }) => (
            view === 'list' ? (
              <div>
                <Button
                  as={Link}
                  size="tiny"
                  compact
                  primary
                  icon="edit"
                  content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                  disabled={loading}
                  to={`/media/pictures/${picture.id}/`}
                />
                <Button
                  size="tiny"
                  compact
                  negative
                  icon="remove"
                  content={isMobile ? null : t('Remove')}
                  disabled={loading}
                  onClick={e => this.handleDelete(e, picture)}
                />
              </div>
            ) : (
              <Button
                as={Link}
                compact size="small"
                attached="bottom"
                primary
                icon="edit"
                content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                disabled={loading}
                to={`/media/pictures/${picture.id}/`}
              />
            )
          )}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(List);



// WEBPACK FOOTER //
// ./src/containers/Pictures/List.jsx